import { Button } from 'antd';

import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { Arrow, IconComment } from '../../../Common/Icon';
import Video from '../../../Common/Video';

import styles from './index.module.scss';
import { useAuth } from '../../../../store/auth';
import useAuthModals from '../../../Layout/Menu/useAuthModals';
import VideoEmpty from '../../../Common/Video/Empty';

function ShareYourTwoCentsHeader() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const { content, openLoginModal } = useAuthModals();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.videoWrapper}>
            <Video
              src="/ShareYourTwoCents.mp4"
              poster="/media/whatIsTippingGuide.png"
            />
            {/* <VideoEmpty /> */}
          </div>
          <div className={styles.innerWrapper}>
            <h2 className={styles.title}>
              <span>
                <span className="colorGreen">Share</span> Your
              </span>
              <span> Two Cents</span>
            </h2>
            <p className={styles.description}>
              <strong>Create a new post</strong> and share your experience with
              tipping and service fees OR
              <strong> Search for a business</strong> to view what other
              customers have to say about their tipping experiences
            </p>

            <div>
              <Button
                icon={<IconComment />}
                type="primary"
                size="large"
                className={styles.button}
                onClick={() =>
                  user ? navigate('/create-new-post') : openLoginModal()
                }
              >
                Create New Post
              </Button>
              {content}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ShareYourTwoCentsHeader;
